

class Resellers {
    constructor(element) {
        //this.isOpen = false;
        this.element = element;

        this.closeAll = this.closeAll.bind(this);
        this.changeView = this.changeViewMode.bind(this);
        this.init = this.init.bind(this);

        this.init();  
    }
    
    
    init() {    

        this.productsCatalouge =  this.element.querySelector(".products-catalouge");
        var productList =   this.productsCatalouge.querySelector(".products-list")
        this.productItem = Array.from(productList.querySelectorAll(".product-item"));
        var currentResellersList;

        this.noResellers =  this.element.querySelector(".noresellers");
        this.allResellersLists = Array.from(productList.querySelectorAll(".resellers-list"));
        var _self = this;

        this.noResellers.classList.add('show');

        window.onload = function() {
            this.currentScreenWidth = window.innerWidth;
            _self.changeViewMode(currentResellersList, false);  
        }

        window.onresize = function( event) {
            _self.changeViewMode(currentResellersList, false);
        } 

        this.productItem.forEach(productItem => {
            var productButton = productItem.querySelector(".product-item-button");
            
            productButton.addEventListener('click', event => {
                currentResellersList = productItem.querySelector(".resellers-list");
                var productCardsParent = currentResellersList.querySelector(".reseller-cards");
                var productCards = Array.from(currentResellersList.querySelectorAll(".reseller-card"));

                setTimeout(() => {
                    if (productCards.length === 1 && productCardsParent.clientHeight > productCards[0].clientHeight) {
                        currentResellersList.classList.add('single');
                    }
                }, 200);
                this.closeAll(currentResellersList);
 
                productButton.classList.add('selected');
                
                this.changeViewMode(currentResellersList, true);  

                if( currentResellersList.classList.contains("anim-in") ) {
                    currentResellersList.classList.remove('anim-in');
                    productButton.classList.remove('selected');
                 
                } else {
                    this.noResellers.classList.remove('show');
                    if( !currentResellersList.classList.contains("show") ) {
                        currentResellersList.classList.add('show');
                    }
                    
                    setTimeout(()=>{
                        currentResellersList.classList.add('anim-in');
                    },100)
                }
                console.log(currentResellersList);
            
                
            })
        });
    }

    closeAll(currentResellersList)  {
        this.allResellersLists.forEach(resellersList => {
            if(resellersList.classList.contains("show") && resellersList !== currentResellersList) {
                resellersList.classList.remove('anim-in');
            }
        }); 

        this.productItem.forEach(productItem => {
            var productButton = productItem.querySelector(".product-item-button");
            if(productButton.classList.contains("selected")) {
                productButton.classList.remove('selected');
            }
        }); 


        this.noResellers.classList.add('show');


    }

    changeViewMode(currentResellersList, force) {
        if( !currentResellersList ) return;
        this.currentScreenWidth = window.innerWidth;
       
        if( this.currentScreenWidth >= 700 && !currentResellersList.classList.contains('height') ) {
            currentResellersList.style.height = this.productsCatalouge.clientHeight + "px";
        } else {
          
            if (currentResellersList.style.removeProperty) {
                currentResellersList.style.removeProperty('height');
            } else {
                currentResellersList.style.removeAttribute('height');
            }

        } 
    }

}

export default Resellers;